import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { Container, Bg, Headline, Text, FeatureContainer } from './styles';
import { AccountFeatureIcon } from './AccountFeatureIcon';

export const AccountFeatures = ({
  headline,
  description,
  features,
  buttonText,
  viewAccountURL,
  onButtonClick,
}) => {
  return (
    <Bg>
      <Container>
        <Headline>{headline}</Headline>
        <Text>{description}</Text>
        <FeatureContainer>
          {features.map((feature, index) => (
            <AccountFeatureIcon {...feature} key={index} />
          ))}
        </FeatureContainer>
        <LinkButton
          href={viewAccountURL}
          variant="secondary"
          horizontalPadding={20}
          verticalPadding={4}
          onClick={onButtonClick}
        >
          {buttonText}
        </LinkButton>
      </Container>
    </Bg>
  );
};
AccountFeatures.displayName = 'AccountFeatures';
AccountFeatures.propTypes = {
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  viewAccountURL: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
};
